import { CONSTANT_ENGLISH_CONTENT } from "../constants/content/en";

export function extractResource(data: any, key: string): string {
  if (data) {
    const value = data[key];
    if (value !== undefined) {
      return value;
    }
  }

  if (CONSTANT_ENGLISH_CONTENT[key] !== undefined) {
    return CONSTANT_ENGLISH_CONTENT[key];
  }

  return key;
}

export function extractFormattedResource(data: any, key: string, ...args: string[]): string {
  const resourceString = extractResource(data, key);
  return resourceString.replace(/\{\}/g, () => args.shift() || '{}');
}
